const DOM_SELECTOR = {
    TITLE: "js-mobile-title",
    TITLE_DESKTOP: ".dcw_submenu-auth_title",
    SUBTITLE: "js-mobile-subtitle",
    BACK_BUTTON: "js-back-btn",
    BACK_BUTTON_DESKTOP: ".dcw_submenu-auth_back-btn",
    HELP_LINK: "js-help-link"
};

let cachedElements = {};

export const HeaderUICache = {
    get title() {
        return getElementByNameOrQuery("title", () => {
            return document.getElementById(DOM_SELECTOR.TITLE);
        });
    },
    set titleDesktop(value) {
        cachedElements.titleDesktop = value;
    },
    get titleDesktop() {
        var element = getElementByNameOrQuery("titleDesktop", () => {
            return document.querySelector(DOM_SELECTOR.TITLE_DESKTOP);
        });

        if (!element) {
            console.log("Unable to find a title desktop DOM element");
        }

        this.titleDesktop = element;
        return element;
    },
    get subtitle() {
        return getElementByNameOrQuery("subtitle", () => {
            return document.getElementById(DOM_SELECTOR.SUBTITLE);
        });
    },
    get backBtn() {
        return getElementByNameOrQuery("backBtn", () => {
            return document.getElementById(DOM_SELECTOR.BACK_BUTTON);
        });
    },
    set backBtnDesktop(value) {
        cachedElements.backBtnDesktop = value;
    },
    get backBtnDesktop() {
        var element = getElementByNameOrQuery("backBtnDesktop", () => {
            return document.querySelector(DOM_SELECTOR.BACK_BUTTON_DESKTOP);
        });

        if (!element) {
            console.log("Unable to find a desktop back button DOM element");
        }

        this.backBtnDesktop = element;
        return element;
    },
    get helpLink() {
        return getElementByNameOrQuery("helpLink", () => {
            return document.getElementById(DOM_SELECTOR.HELP_LINK);
        });
    }
};

function getElementByNameOrQuery(name, query) {
    if (!cachedElements[name]) {
        cachedElements[name] = query();
    }

    return cachedElements[name];
}



// WEBPACK FOOTER //
// ./src/js/api/header/headerUICache.js